(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
 class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this._ticking = false;

      this.initHeaderHeightObserver();
      this.header.classList.add('shopify-section-header-sticky');

      this.predictiveSearch = this.querySelector('predictive-search');
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => { this.preventReveal = true; };

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, { passive: true });
      this.createObserver();
    }

    initHeaderHeightObserver() {
      if (!this.header) return;
      this._ro = new ResizeObserver((entries) => {
        const h = Math.ceil(entries[0].contentRect.height || 0);
        document.documentElement.style.setProperty('--header-height', `${h}px`);
      });
      this._ro.observe(this.header);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this._ro?.disconnect?.();
    }

    createObserver() {
      const o = new IntersectionObserver((entries, obs) => {
        this.headerBounds = entries[0].intersectionRect;
        obs.disconnect();
      });
      o.observe(this.header);
    }

onScroll() {
      if (this.predictiveSearch?.isOpen) return;
      // อย่าซ่อน/โผล่ header ตอนกล่องค้นหา หรือ drawer เมนูเปิดอยู่ (กันเด้งปิดเอง)
      if (document.documentElement.classList.contains('pnl-search-open') ||
          document.documentElement.classList.contains('pnl-drawer-open')) {
        this.currentScrollTop = window.scrollY || document.documentElement.scrollTop || 0;
        return;
      }
      if (this._ticking) return;
      this._ticking = true;
      requestAnimationFrame(() => {
        const y = window.scrollY || document.documentElement.scrollTop || 0;
        const bottom = this.headerBounds.bottom || 0;
        const delta = y - this.currentScrollTop;

        // ปัดขึ้นเล็กน้อย (เกิน 4px) → โผล่หัวเว็บทันที
        if (delta < -4 && y > bottom) {
          this.header.classList.add('scrolled-past-header');
          this.reveal();
        // ปัดลง (เกิน 4px) และพ้น header แล้ว → ซ่อน
        } else if (delta > 4 && y > bottom) {
          this.header.classList.add('scrolled-past-header');
          if (!this.preventHide) this.hide();
        // ถึงบนสุด → reset
        } else if (y <= (this.headerBounds.top || 0)) {
          this.header.classList.remove('scrolled-past-header');
          this.reset();
        }

        this.currentScrollTop = y;
        this._ticking = false;
      });
    }

  hide() {
      // ถ้ากล่องค้นหา/drawer เปิดอยู่ อย่าซ่อน header (กันปิด modal เอง)
      if (document.documentElement.classList.contains('pnl-search-open') ||
          document.documentElement.classList.contains('pnl-drawer-open')) {
        return;
      }
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      /* บังคับแสดงผลตอนเลื่อนขึ้นเสมอ */
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((d) => d.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }
  

  } catch(e) { console.error(e); }
})();
})();
